import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getLatestProposal } from '@/app/shared/services/api';

export const useLatestProposal = () => {
    const { data, isLoading } = useQuery({
        queryKey: [QueryKeys.LATEST_PROPOSAL],
        queryFn: getLatestProposal,
        staleTime: 60_000,
        enabled: false,
    });

    const proposal = data?.proposal;
    const isActive = proposal?.state === 'active';

    return { proposal, isActive, isLoading };
};